import React, { useState } from 'react'
import Popup from './popup'

export default function GameCard(props) {
  const { event, selected, newLocations } = props
  let overPopup = false
  const [showPopup, setShowPopup] = useState(false)
  const [showTime, setShowTime] = useState(false)
  let timer = null
  const fullWithfakes = (event.number_of_fakes > 0 && event.number_of_players + event.number_of_fakes == event.total_spots)
  const atNewLocation = newLocations[event.location_id]
  
  const gameStatus = () => {
    if (event.spots_remaining == 0) {
      return <div className='game-status'>Game Full</div>
    }
    if (fullWithfakes) {
      return <div className='game-status'>! Game Full !</div>
    }
    else if (event.spots_remaining <= 3) {
      const pluralSpot = event.spots_remaining > 1 ? 's' : ''

      return <div className='spots-status'>
        { event.spots_remaining + ' Spot' + pluralSpot + ' Left'}
      </div>
    }
    else {
      return <div  className='player-status'>
        { event.number_of_players + ' / ' + event.total_spots + ' Spots Filled'}
      </div>
    }
  }

  const handleGameClicked = () => {
    selected !== undefined ? props.onGamesSelect({id: event.id}) : openGameModal()
  }

  const onShowPopup = () => {
    setShowPopup(true)
  }

  const onHidePopup = () => {
    clearTimeout(timer)
    timer = setTimeout(function () { 
      if (!overPopup) setShowPopup(false) 
    }, 200)
  }

  const onEnterPopup = () => {
    overPopup = true
  }

  const onLeavePopup = () => {
    overPopup = false
    setShowPopup(false)
  }

  const openGameModal = (activeTab = 'game-details') => {
    props.onShowGameModal({gameId: event.id, activeTab: activeTab})
  } 

  const onGameMessages = (e) => {
    e.stopPropagation()
    openGameModal('game-messages')
  }

  const avatarBorderClass = () => {
    if (event.pre_booked) return ' purple-border'
    if (event.confirmed_with_facility) return ' blue-border'
    return ''
  }

  const onAvatarClick = (e) => {
    e.stopPropagation()
    if (event.pre_booked || event.confirmed_with_facility)     
      props.onUpdateWithFacility({id: event.id, confirmed: false, pre_booked: false})
    else
      props.onUpdateWithFacility({id: event.id, confirmed: true, pre_booked: false})
  }

  const completedClass = (event.todos_count == event.todos_done_count) ? ' completed' : ''

  return <div 
    className='col-xs-12 col-sm-6 col-md-4 col-lg-3' 
    key={event.id}
    onMouseEnter={() => setShowTime(true)}
    onMouseLeave={() => setShowTime(false)}
  >
    <div className={'reservation-card hovercard' + (fullWithfakes ? ' full-with-fakes' : '')}>
      { showPopup &&
        <Popup
          eventId={event.id}
          eventIndex={props.eventIndex}
          doneCount={event.todos_done_count} 
          onEnter={onEnterPopup} 
          onLeave={onLeavePopup} 
          onTodoChange={props.onTodoChange}
        />
      }
      <a className='clickable' id='open-game-link' onClick={handleGameClicked}>
        <div className='cardheader'>
          <div className='col-xs-5 col-md-4'>
            <div
              className={`avatar${avatarBorderClass()}`}
              onClick={(e) => onAvatarClick(e)}>
              { props.unseen && 
                <div className='unseen' onClick={(e) => onGameMessages(e)}>
                  <div className='unseen-circle'></div>
                </div>
              }
              <img alt='' src={event.logo} />
            </div>
          </div>
          <div className='col-xs-7 col-md-8 event-time'>
            {selected == undefined
              ? <div className='event-top'>
                  <div 
                    className='event-deep-link'
                    onClick={(e) => {
                      e.stopPropagation()
                      navigator.clipboard.writeText(`https://pleiapp.onelink.me/tXi7?deep_link_value=plei_games&deep_link_sub1=${event.id}`)
                    }}
                  />
                  { atNewLocation != undefined &&
                    <div className='event-new-facility'><span>{`New Facility (${atNewLocation})`}</span></div>
                  }
                  { event.todos_count > 0 &&
                    <div 
                      className={'event-todo-list' + completedClass} 
                      onMouseEnter={onShowPopup}
                      onMouseLeave={onHidePopup}
                      onClick={(e) => e.stopPropagation()}
                    />
                  }
                </div>
              : <div className='game-select'>
                  <input
                    type='checkbox'
                    checked={selected}
                    readOnly={true}
                  />
                </div>
            }
            <div className='confirmed-status'>
              { event.confirmed && <i className='fa fa-check-circle fa-2x'></i> }
              <span className='event-time-text'>{event.display_time}</span>
            </div>
            {showTime && event.timezone &&
              <div className='local-time'>
                {moment(Date.now()).tz(event.timezone).format('hh:mm A z')}
              </div>
            }
          </div>
        </div>
        <div className='title card-body' id='card-body-panel'>
          <div className='badge-container'>
            { event.organizer_game && <div className='organizer-badge'>Organizer</div> }
          </div>
          { gameStatus(event) }
          <div className='game-name' title={event.name}>{event.name}</div>
          <div className='min-max-player'>
            {event.min_players + ' Min' + ' | ' + event.total_spots + ' Max'}
          </div>
          <div className='skill-level'>{event.skill_level}</div>
        </div>
      </a>

      <div className='info row'>
        <div className='col-xs-4'>
          <div className='left-icons-panel'>
          { 
            event.reviews &&
              <a className='clickable' onClick={() => openGameModal('game-reviews')}>
                <div className='like-icon'></div>
              </a>
          }
          </div>
        </div>
        <div className='col-xs-4'>
          <a onClick={() => props.onEditGame({type: 'edit', id: event.id})}>
            <div className='btn edit-game-btn'>
              <span className='text-center'>Edit</span>
            </div>
          </a>
        </div>
        <div className='col-xs-4'>
          <div className='right-icons-panel'>
          { !!event.declined.length && <div className='declined-icon'></div> }
          { event.notes && 
            <a className='clickable'  onClick={() => openGameModal('game-comment')}>
              <div className='notes-icon'></div>
            </a> 
          }
          </div>
        </div>            
      </div>
    </div>
  </div>
}
